import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { csn } from '@one-vision/utils';
import { useStyles } from './dz-credit-card-form.styles';
import { useTheme } from '@mui/material';
const DzCreditCardForm = ({ onChangeHandler }) => {
    const theme = useTheme();
    const classes = useStyles();
    const [focused, setFocused] = useState(false);
    const focusHandler = useCallback(() => {
        setFocused(true);
    }, [setFocused]);
    const blurHandler = useCallback(() => {
        setFocused(false);
    }, [setFocused]);
    return (_jsx(CardElement, { options: {
            style: { base: { color: theme.palette.custom.OV.sys.onSurface } },
            classes: {
                base: csn(classes.inputStyled, [classes.focused, focused]),
            },
            hidePostalCode: true,
        }, onChange: onChangeHandler, onFocus: focusHandler, onBlur: blurHandler }));
};
export default DzCreditCardForm;
